module.exports = __webpack_public_path__ + "static/media/YB5M05_2.14e97aa4.jpg";